import { Card, Col, Flex, Row } from 'antd'

import { useTreatmentServiceGetPregnancyMonitoringEndpoint } from 'src/api/queries'
import {
  GetConsultationResponse,
  PregnancyLocalization
} from 'src/api/requests'
import { Text } from 'src/components'
import { formatDate } from 'src/libs'
import { useLocales } from 'src/locales'

type Props = {
  data?: GetConsultationResponse
}

export const DetailsPregnancy = ({ data }: Props) => {
  const { t } = useLocales()

  const { data: pregnancyDetails, isLoading } =
    useTreatmentServiceGetPregnancyMonitoringEndpoint(
      {
        id: String(data?.pregnancyMonitoringId)
      },
      [String(data?.pregnancyMonitoringId)],
      {
        enabled: !!data?.pregnancyMonitoringId
      }
    )

  const PersonLocalizationStatus = {
    [PregnancyLocalization.INTRAUTERINE]: t(
      'pregnancy.pregnant_localization_status.intrauterine'
    ),
    [PregnancyLocalization.EXTRAUTERINE]: t(
      'pregnancy.pregnant_localization_status.extrauterine'
    )
  }

  return (
    <Card>
      <Flex vertical gap={16}>
        <Card title={t('pregnancy.pregnancy')} loading={isLoading}>
          <Flex gap={24} vertical>
            <Flex vertical gap={24}>
              <Row gutter={[24, 24]}>
                <Col span={24}>
                  <Flex vertical gap={8}>
                    <Text weight={700}>{t('pregnancy.age')}</Text>

                    <Flex gap={8} wrap="wrap">
                      {pregnancyDetails?.gestationalAgeInWeeks}
                    </Flex>
                  </Flex>
                </Col>

                <Col span={12}>
                  <Flex vertical gap={8}>
                    <Text weight={700}>
                      {t('pregnancy.last_gestation_date')}
                    </Text>

                    <Flex gap={8} wrap="wrap">
                      {formatDate(pregnancyDetails?.lastMenstrualPeriod)}
                    </Flex>
                  </Flex>
                </Col>

                <Col span={12}>
                  <Flex vertical gap={8}>
                    <Text weight={700}>
                      {t('pregnancy.estimated_birth_date')}
                    </Text>

                    <Flex gap={8} wrap="wrap">
                      {formatDate(pregnancyDetails?.expectedDateOfBirth)}
                    </Flex>
                  </Flex>
                </Col>

                <Col span={12}>
                  <Flex vertical gap={8}>
                    <Text weight={700}>{t('pregnancy.pregnancy_type')}</Text>

                    <Flex gap={8} wrap="wrap">
                      {t(
                        `pregnancy.pregnancy_type_status.${pregnancyDetails?.pregnancyType}`
                      )}
                    </Flex>
                  </Flex>
                </Col>

                <Col span={12}>
                  <Flex vertical gap={8}>
                    <Text weight={700}>
                      {t('pregnancy.pregnancy_localization')}
                    </Text>

                    <Flex gap={8} wrap="wrap">
                      {pregnancyDetails?.pregnancyLocalization
                        ? PersonLocalizationStatus[
                            pregnancyDetails?.pregnancyLocalization
                          ]
                        : '-'}
                    </Flex>
                  </Flex>
                </Col>
              </Row>
            </Flex>
          </Flex>
        </Card>

        <Card className="full-width">
          <Row gutter={[24, 24]}>
            <Col span={24}>
              <Flex vertical gap={8}>
                <Text weight={700}>{t('common.date')}</Text>

                <Flex gap={8} wrap="wrap">
                  {formatDate(
                    pregnancyDetails?.pregnancyStatusChangedDate ?? ''
                  )}
                </Flex>
              </Flex>
            </Col>

            <Col span={24}>
              <Flex vertical gap={8}>
                <Text weight={700}>{t('common.comment')}</Text>

                <Flex gap={8} wrap="wrap">
                  {pregnancyDetails?.pregnancyStatusChangedComment}{' '}
                </Flex>
              </Flex>
            </Col>
          </Row>
        </Card>
      </Flex>
    </Card>
  )
}
